import { Phone, MessageCircle, MapPin } from "lucide-react";
import { CONTACT } from "@/data/site";

// Sticky bottom action bar (mobile only)
export const MobileActionBar = () => (
  <div
    data-testid="mobile-action-bar"
    className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-brand-line bg-white/95 backdrop-blur-xl xl:hidden"
  >
    <a
      href={CONTACT.phoneTel}
      data-testid="sticky-call"
      className="flex flex-col items-center gap-0.5 py-2.5 text-brand-blue"
    >
      <Phone className="h-5 w-5" />
      <span className="text-[11px] font-semibold">Call</span>
    </a>
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-whatsapp"
      className="flex flex-col items-center gap-0.5 border-x border-brand-line py-2.5 text-brand-greenhover"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="text-[11px] font-semibold">WhatsApp</span>
    </a>
    <a
      href={CONTACT.gmbUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-directions"
      className="flex flex-col items-center gap-0.5 py-2.5 text-brand-dark"
    >
      <MapPin className="h-5 w-5" />
      <span className="text-[11px] font-semibold">Directions</span>
    </a>
  </div>
);
